import { throttle } from "lodash";
import { useEffect, useState } from "react";

export function useCategoryInView(): [
  string | null | undefined,
  React.Dispatch<React.SetStateAction<string | null | undefined>>
] {
  const [categoryInView, setCategoryInView] = useState<string | null>();
  useEffect(() => {
    const calculateCategoryInView = (): string | null => {
      const categories = document?.querySelectorAll(".category");
      if (!categories || categories.length === 0) return null;

      const header = document?.querySelector("header");
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const windowHeight =
        window?.innerHeight || document?.documentElement?.clientHeight;

      let maxVisibleHeight = 0;
      let dominantCategory: string | null = null;

      for (const category of categories) {
        const rect = category.getBoundingClientRect();

        const visibleHeight = Math.max(
          0,
          Math.min(windowHeight, rect.bottom) - Math.max(headerHeight, rect.top)
        );

        if (visibleHeight > 0 && visibleHeight > maxVisibleHeight) {
          maxVisibleHeight = visibleHeight;
          dominantCategory = category.id;
        }
      }

      return dominantCategory;
    };

    const handleScroll = throttle(() => {
      const currentCategory = calculateCategoryInView();
      setCategoryInView(() => currentCategory);
    }, 200);
    // container with scrollable content
    const mainElement = document?.querySelector("main");
    mainElement?.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      mainElement?.removeEventListener("scroll", handleScroll);
      handleScroll.cancel();
    };
  }, []);

  return [categoryInView, setCategoryInView];
}
